import appConfig from '@/appConfig';
import useRoutes from '@/authority/useRoutes';
import { userLimitList } from '@api/permission';
import AuthRoute from '@authority/AuthRoute';
import { BASE_NAME, IS_DEV, TOKEN_KEY } from '@constants/index';
import { routerInterFace } from '@router/types';
import { i18nLang, userInfo } from '@store';
// import { transformRoute } from '@umijs/route-utils';
import { getStorage } from '@utils/localStorageService';
import { getFlatRouterList } from '@utils/tool';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import _ from 'lodash';
import React, { ReactElement, Suspense, useEffect, useMemo } from 'react';
import { AliveScope, KeepAlive } from 'react-activation';
import { getI18n } from 'react-i18next';
import { Route, Routes, useLocation, useNavigate } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import LazyLoader from './LazyLoader';
import { dayjsMap, pcLocale } from './i18n';
import RedirectPage from './views/redirectPage';
import '@assets/beyond-online-fonts/fonts.css';
dayjs.extend(localeData);

// PC端
const Admin = React.lazy(() => import('./views/admin'));
const Login = React.lazy(() => import('./views/login'));
const Error = React.lazy(() => import('./views/notFound'));
const TemporaryNoPhonePage = React.lazy(
  () => import('./views/temporaryNoPhonePage')
);
const EmailConfirmation = React.lazy(() => import('./views/emailPage'));

const theme = {
  token: {
    colorPrimary: '#0072EF'
  }
};

const Redirect = ({ to }: { to: string }): ReactElement | null => {
  const navigate = useNavigate();
  const { state } = useLocation();
  useEffect(() => {
    navigate(to, { state });
  }, []);
  return null;
};

const App = (): ReactElement => {
  const [userInfos, setUserInfo] = useRecoilState(userInfo);
  const lang = useRecoilValue(i18nLang);
  const ilang = lang || getI18n().language;
  const pLocle = pcLocale[ilang];
  dayjs.locale(dayjsMap[ilang]);
  dayjs().localeData();
  const routes = useRoutes(appConfig.routerType);
  // const { menuData } = transformRoute(routes);

  // 获取权限，并加在用户信息中
  const getUserAuthority = () => {
    userLimitList().then((res: { userResources: any }) => {
      const userinfoList = res?.userResources?.sort(
        (a: any, b: any) => a?.sortNum - b?.sortNum
      );
      const userInfo = _.cloneDeep(userInfos);
      userInfo.authority = userinfoList;
      setUserInfo(userInfo);
    });
  };

  // 判断是否登录
  const userTokens = getStorage(TOKEN_KEY);
  useEffect(() => {
    if (userTokens) {
      getUserAuthority();
    }
  }, [userTokens]);

  const flatRouterList = useMemo(() => getFlatRouterList(routes), [routes]);
  return (
    <ConfigProvider
      locale={pLocle}
      theme={theme}
      prefixCls="zeiss"
      // dropdownMatchSelectWidth={true}
      popupMatchSelectWidth={true}
    >
      <div className="App" key={ilang}>
        <BrowserRouter basename={IS_DEV ? '' : BASE_NAME}>
          <AliveScope>
            <Suspense fallback={<LazyLoader delay={300} />}>
              <AuthRoute>
                <Routes>
                  <Route
                    path="/"
                    element={<Redirect to={'/announcement'} />}
                  ></Route>
                  <Route path="/" element={<Admin />}>
                    {routes.length &&
                      flatRouterList.map((val: routerInterFace) => (
                        <Route
                          key={val.path}
                          path={val.path}
                          element={
                            val.keepalive ? (
                              <KeepAlive id={val.path}>
                                {val.component}
                              </KeepAlive>
                            ) : (
                              val.component
                            )
                          }
                        ></Route>
                      ))}
                  </Route>
                  <Route
                    path="/confirmation"
                    element={<EmailConfirmation />}
                  ></Route>
                  <Route path="/login" element={<Login />}></Route>
                  <Route
                    path="/temporaryNoPhonePage"
                    element={<TemporaryNoPhonePage />}
                  ></Route>
                  <Route path="/redirect" element={<RedirectPage />}></Route>
                  <Route path="*" element={<Error />}></Route>
                </Routes>
              </AuthRoute>
              {/* <Routes>
                <Route path="/redirect" element={<RedirectPage />}></Route>
              </Routes> */}
            </Suspense>
          </AliveScope>
        </BrowserRouter>
      </div>
    </ConfigProvider>
  );
};

export default App;
